<template>
  <div id="character-skills-wrap">
    <p class="subnote">Assign these scores to your stats: 16(+2), 15(+1), 13(+1), 12(–), 9(–), 8(-1)</p>
    <div class="character-skills">
      <div class="character-skill" v-for="skill in skills" :key="skill.abreviation">
        <p>{{ skill.name }}</p>
        <div class="skill-point">
          <span class="abreviation">{{ skill.abreviation }}</span>
          <input type="number" min="0" v-model="skill.score" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Skills, (√) Armor, (√) Hit Points, (√) Damage
export default {
  name: "CharacterSkills",
  computed: {
    skills: {
      get() {
        return this.$store.state.character.skills;
      },
      set(value) {
        this.$store.commit("updateCharacterSkills", value);
      }
    }
  }
};
</script>

<style lang="css">
#character-skills-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
}

.character-skills {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 16px;
}

.character-skill {
  width: 23%;
  max-height: 3.5em;
  margin: 0.5em;
  margin-bottom: 3em;
  padding: 0.7em;
  background: linear-gradient(180deg, white 45%, #22272c 45%);
  border: 1px solid #2c3e50;
}

.character-skill p {
  text-align: left;
}

.skill-point {
  width: 4em;
  height: 4em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #2c3e50;
  border-radius: 100%;
  background: white;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 500;
}

.skill-point input {
  width: 50%;
  text-align: center;
  height: 1em;
  border: none;
}
</style>